import _ from 'lodash';
import moment from 'moment';

import {TOTAL, OCCUPANCY_STATUSES} from 'ducks/occupancy';
import {DATE_FORMAT_API} from 'utils/datetime';

export const buildColumn = column => ({
  date: moment(column.date, DATE_FORMAT_API),
  barValues: buildBarValues(column),
  tableData: buildColumnTableData(column)
});

const buildBarValues = column => {
  const roomTypeGroups = _.keys(column.report.roomTypeGroupBreakdown);
  const totalRooms = unifyTotals(column.report.total).totalRooms;

  return _.reduce(
    roomTypeGroups,
    (result, roomTypeGroupName) => ({
      ...result,
      [roomTypeGroupName]: buildBarValue(
        roomTypeGroupName,
        unifyTotals(
          column.report.roomTypeGroupBreakdown[roomTypeGroupName].total
        ),
        totalRooms
      )
    }),
    {}
  );
};

const unifyTotals = totals => ({
  booked: totals.real.booked + totals.dummy.booked,
  confirmed: totals.real.confirmed + totals.dummy.confirmed,
  reserved: totals.real.reserved + totals.dummy.reserved,
  available: totals.real.available,
  occupiedByEt: totals.real.occupiedByEt + totals.dummy.occupiedByEt,
  occupiedByEc: totals.real.occupiedByEc + totals.dummy.occupiedByEc,
  outOfOrder: totals.real.outOfOrder,
  totalRooms: totals.real.totalRooms,
  longStayRooms: totals.real.longStayRooms
});

const buildColumnTableData = column => {
  const roomTypeGroups = _.keys(column.report.roomTypeGroupBreakdown);
  const roomTypeGroupsTableData = _.reduce(
    roomTypeGroups,
    (result, roomTypeGroupName) => ({
      ...result,
      [roomTypeGroupName]: {
        groupValue: buildRoomTypeGroupValue(
          column.report.roomTypeGroupBreakdown[roomTypeGroupName].total.real
        ),
        nestedElements: buildRoomTypeValue(
          column.report.roomTypeGroupBreakdown[roomTypeGroupName]
            .roomTypeBreakdown
        )
      }
    }),
    {}
  );

  return {
    [TOTAL]: buildRoomTypeGroupValue(column.report.total.real),
    ...roomTypeGroupsTableData
  };
};

const buildRoomTypeGroupValue = occupancy => ({
  value: _.get(occupancy, OCCUPANCY_STATUSES.AVAILABLE, 0),
  maxValue: _.get(occupancy, OCCUPANCY_STATUSES.TOTAL_ROOMS, 0),
  displayValue: _.get(occupancy, OCCUPANCY_STATUSES.LONG_STAY_ROOMS, 0)
});

const buildRoomTypeValue = roomTypeGroup => {
  return _.mapValues(roomTypeGroup, roomType => ({
    label: roomType.label,
    value: roomType.real[OCCUPANCY_STATUSES.AVAILABLE],
    maxValue: roomType.real.totalRooms
  }));
};

export const buildTableHeaderData = columns => {
  const breakDown = _.get(columns, '[0].report.roomTypeGroupBreakdown', {});

  return _.reduce(
    breakDown,
    (result, roomTypeGroup, key) => [
      ...result,
      {
        label: key,
        value: key,
        totalRooms: _.get(
          roomTypeGroup.total.real,
          OCCUPANCY_STATUSES.LONG_STAY_ROOMS,
          0
        ),
        nestedElements: buildRoomTypesForGroup(roomTypeGroup.roomTypeBreakdown)
      }
    ],
    []
  );
};

const buildRoomTypesForGroup = roomTypeGroup =>
  _.reduce(
    roomTypeGroup,
    (roomTypesResult, roomType, key) => [
      ...roomTypesResult,
      {
        label: roomType.label,
        value: key,
        totalRooms: roomType.real[OCCUPANCY_STATUSES.LONG_STAY_ROOMS]
      }
    ],
    []
  );

const buildBarValue = (roomTypeGroup, data, totalRooms) => ({
  value: _.get(data, OCCUPANCY_STATUSES.AVAILABLE, 0),
  maxValue: _.get(data, 'totalRooms', 0),
  tooltipData: [
    {
      label: `Total ${roomTypeGroup} available (of total building)`,
      value: _.get(data, OCCUPANCY_STATUSES.AVAILABLE, 0),
      maxValue: totalRooms
    }
  ]
});
